import { createContext } from 'react';

export const MethodSystemContext = createContext("");